import { render, staticRenderFns } from "./CooperativeCirculationInfo.vue?vue&type=template&id=2a8b2860&scoped=true&"
import script from "./CooperativeCirculationInfo.vue?vue&type=script&lang=js&"
export * from "./CooperativeCirculationInfo.vue?vue&type=script&lang=js&"
import style0 from "./CooperativeCirculationInfo.vue?vue&type=style&index=0&id=2a8b2860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b2860",
  null
  
)

export default component.exports